<div matDialogTitle>Förnya xertifikat</div>
<mat-dialog-content>
  <p>Förnya certifikaten genom att ange ett <i>deploytoken</i>. Har du inget token så fråga Daniel. </p>
  <p>Detta är egentligen bara ett experiment då man lika gärna kan starta rörledningen direkt i
    <a href="https://gitlab.com/akiru/tooling/lets-encrypt/-/pipelines/new" target="_blank">Gitlab</a></p>
  <mat-form-field>
    <mat-label>Deploytoken</mat-label>
    <input
      #tok=ngModel
      [(ngModel)]="token"
      matInput
      minlength="20"
      required
      name="token"
      placeholder="glptt-xiSAy7dnztT1obPRt2sr"
    >
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-dialog-close matButton="text">Avbryt</button>
  <button (click)="sendRequest()"
          [disabled]="tok.invalid"
          matButton="filled">Skicka
  </button>
</mat-dialog-actions>
